import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient.ts';

export type GraphErrorDetails = {
	networkError?: Error | null;
	graphQLErrors?: readonly unknown[];
};

export const classifyGraphError = (error: GraphErrorDetails): 'network' | 'graphql' =>
	!error.networkError && error.graphQLErrors?.length ? 'graphql' : 'network';

export const reportHandledGraphError = (error: Error): void => {
	getMonitoringClient().submitError(error, { attribution: Attribution.INTEGRATIONS });
	markErrorAsHandled(error);
};

export const reportUnexpectedGraphPipelineError = (error: unknown): void => {
	getMonitoringClient().submitError(error instanceof Error ? error : new Error(String(error)), {
		attribution: Attribution.INTEGRATIONS,
	});
};
